import { FunctionalComponent } from 'preact';
import { cn } from '../../utilities';
import './style.css';

export interface ICheckboxProps {
  class?: string;
  label?: string;
  onCheck?: (event: Event) => void;
}

const Checkbox: FunctionalComponent<ICheckboxProps> = (props) => {
  return (
    <label class={cn(props.class, 'cw-check cw-option')}>
      <input class="cw-check__input" type="checkbox" onInput={props.onCheck} />
      <svg class="cw-check__box" viewBox="0 0 20 20">
        <rect class="cw-check__focus" width="20" height="20" rx="4" />
        <rect class="cw-check__square" x="3" y="3" width="14" height="14" rx="2" />
        <polyline class="cw-check__mark" points="5 9 9 13 15 6" />
      </svg>
      <span class="cw-check__label">{props.label}</span>
    </label>
  );
};

Checkbox.defaultProps = {
  onCheck: () => {},
};

export { Checkbox };
